<template>
  <mini-card :value="value" :previousValue="previousValue||''" subtitle="Affiliates">
    <div slot="header" class="icon-warning">
      <i class="fad fa-user-friends text-warning"></i>
    </div>
    <template slot="footer">
      <div class="row small">
        <a class="ml-3" href="#" @click="inviteAffiliate()"><i class="fas fa-plus mr-1"/>affiliate</a>
        <!-- <a class="mr-3 ml-auto" href="#"><i class="far fa-edit mr-1"/>manage</a> -->
      </div>
    </template>
  </mini-card>
</template>

<script>
import MiniCard from './MiniCard.vue'
import {AffiliateProxy} from 'src/classes/datamodel.js'
export default {
    name: 'Affiliates-MiniCard',
    components: {
      MiniCard
    },
    computed: {
      value () {
        var nb = 0
        this.$store.getters.affiliates.forEach(elem => !elem.archived && elem.affiliateIncentifyerRelationship.status == 'active' ? nb++ : '')
        return nb
      },
      previousValue () {
        //console.log(this.$store.getters.affiliatesPrevious.length)
        // return this.$store.getters.affiliatesPrevious.length
        return ''
      }
    },
    methods: {
      inviteAffiliate () {
        this.$store.dispatch('openModal', { name: 'Invite Affiliate',
                                            mode: 'Invite',
                                            object: new AffiliateProxy() })
      }
    }

}
</script>

<style>

</style>